import { useEffect } from "react";

// Modals can stack (e.g. a ConfirmModal on top of the edit challenge modal), so the
// body lock is reference-counted: only the last lock holder restores scrolling.
let lockCount = 0;

export const useLockBodyScroll = (lock: boolean) => {
  useEffect(() => {
    if (!lock) return;
    lockCount++;
    document.body.style.overflow = "hidden";
    return () => {
      lockCount--;
      // Clear the inline style instead of forcing "visible" so the stylesheet default applies
      if (lockCount === 0) document.body.style.overflow = "";
    };
  }, [lock]);
};
